import { FunctionComponent, lazy } from 'react'
import { NPSProvider } from './contexts/NPSContext'
import { Route, Switch } from 'react-router-dom'

const ConsultationRating = lazy(
  () => import('@/modules/NPS/pages/ConsultationRating'),
)
const ConsultationRatingSuccess = lazy(
  () => import('@/modules/NPS/pages/ConsultationRatingSuccess'),
)

const routes = [
  <Route
    path="/avaliacao/:consultationId"
    key="/avaliacao/:consultationId"
    exact
    component={ConsultationRating}
  />,
  <Route
    path="/avaliacao/:consultationId/app/:platform"
    key="/avaliacao/:consultationId"
    exact
    component={ConsultationRating}
  />,
  <Route
    path="/avaliacao/:consultationId/sucesso"
    key="/avaliacao/:consultationId/sucesso"
    exact
    component={ConsultationRatingSuccess}
  />,
  <Route
    path="/avaliacao/:consultationId/app/:platform/sucesso"
    key="/avaliacao/:consultationId/app/:platform/sucesso"
    exact
    component={ConsultationRatingSuccess}
  />,
]

const NPSRoutes: FunctionComponent = () => (
  <NPSProvider>
    <Switch>{routes}</Switch>
  </NPSProvider>
)

export default NPSRoutes
